import styled from '@emotion/styled';
import { Space } from 'antd';
import type { FC } from 'react';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import {
  IconInvisibleRegular,
  IconStarRegular,
  IconStarSolid,
  IconVisibleRegular,
} from '../../BasicComponents/Icons';

interface Props {
  isSelected?: boolean;
  isVisible: boolean;
  onHideClick?: (
    _e:
      | React.MouseEvent<SVGSVGElement>
      | React.KeyboardEvent<SVGSVGElement>
      | React.TouchEvent<SVGSVGElement>,
  ) => void;
}

export const SelectionControls: FC<Props> = ({ isSelected, isVisible, onHideClick }) => {
  return (
    <StarterControlsWrapper size={0}>
      {isSelected != null ? isSelected ? <IconStarSolid /> : <IconStarRegular /> : null}
      {isVisible ? (
        <IconVisibleRegular {...onClickGenerator(onHideClick)} />
      ) : (
        <IconInvisibleRegular {...onClickGenerator(onHideClick)} />
      )}
    </StarterControlsWrapper>
  );
};

const StarterControlsWrapper = styled(Space)`
  svg {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 15px;
      width: 30px;
      color: var(--player-color-dark-grey);

      &:hover {
        color: var(--player-text-color);
      }

      &[data-icon='star'][data-prefix='fas'] {
        color: var(--base-color);
      }
    }
`;
